import React from "react";

function DiagnoseItem({ item, onClick, selected }: any) {
  // Color mapping for common named colors
  const namedColorMap: { [key: string]: string } = {
    red: "255, 0, 0",
    blue: "0, 0, 255",
    green: "0, 128, 0",
    yellow: "255, 255, 0",
    orange: "255, 165, 0",
    purple: "128, 0, 128",
    pink: "255, 192, 203",
    black: "0, 0, 0",
    white: "255, 255, 255",
    gray: "128, 128, 128",
    grey: "128, 128, 128",
  };

  // Helper function to convert any color to rgba with 50% opacity
  const getColorWithOpacity = (color: string, alpha: number = 0.5): string => {
    // Handle hex colors
    const hexMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    if (hexMatch) {
      const r = parseInt(hexMatch[1], 16);
      const g = parseInt(hexMatch[2], 16);
      const b = parseInt(hexMatch[3], 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    
    // Handle named colors
    const lowerColor = color.toLowerCase();
    if (namedColorMap[lowerColor]) {
      return `rgba(${namedColorMap[lowerColor]}, ${alpha})`;
    }
    
    // Fallback: return original color if conversion fails
    return color;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        backgroundColor: selected ? getColorWithOpacity(item.color, 0.5) : undefined,
        color: item.diagnose === "Clear"  ? undefined : item.color,
        border: item.diagnose === "Clear" ? undefined : `1px solid ${item.color}`,
      }}
      className={`px-3 py-2 rounded-lg border-2 text-xs font-medium transition-all hover:shadow-md w-[100px] ${
        selected ? "shadow-lg" : ""
      } ${!selected ? "bg-white dark:bg-slate-700 border-slate-200 dark:border-slate-600" : ""} ${
        item.diagnose === "Clear" ? "text-black dark:text-slate-200 border-black dark:border-slate-500" : ""
      }`}
    >
      {item.diagnose}
    </button>
  );
}

export default DiagnoseItem;
